module.exports = __webpack_public_path__ + "img/arrow-navigation.6dc14bd1.svg";